import DatepickerInput from '@/components/refinedev/DatepickerInput';
import {ThousandSeparatorTextInput} from '@/components/refinedev/MaskTextInput';
import TextareaInput from '@/components/refinedev/TextareaInput';
import TextInput from '@/components/refinedev/TextInput';
import Section from '@/components/surface/Section';
import ProjectMemberInput from './components/project-member-input';
import formatter from '@/lib/formatter';
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/shadcn_components/ui/tabs';
import {FileInput} from '@/components/refinedev/FileInput';
import {CanAccess} from '@refinedev/core';

const ProjectForm = () => {
  return (
    <Tabs defaultValue="general_info">
      <TabsList className="flex gap-x-4 bg-primary">
        <TabsTrigger className="text-white" value="general_info">
          Thông tin chung
        </TabsTrigger>
        <CanAccess resource="users" action="list">
          <TabsTrigger className="text-white" value="members">
            Nhân sự dự án
          </TabsTrigger>
        </CanAccess>
        {/* <TabsTrigger value="documents">Tài liệu đính kèm</TabsTrigger> */}
        {/* {m.id && <TabsTrigger value="tasks">Công việc</TabsTrigger>} */}
      </TabsList>

      <TabsContent value="general_info" forceMount className="mt-2">
        <Section className="w-full mx-auto" title="Thông tin chung" subtitle="Nhập thông tin dự án">
          <ProjectForm.GeneralInfo />
        </Section>
      </TabsContent>

      <CanAccess resource="users" action="list">
        <TabsContent value="members" forceMount>
          <Section
            className="w-full mx-auto"
            title="Nhân sự dự án"
            subtitle="Thông tin người quản lý và thành viên dự án">            
            <ProjectMemberInput />
          </Section>
        </TabsContent>
      </CanAccess>

      {/* <TabsContent value="documents" forceMount>
        <Section title="Tài liệu đính kèm" subtitle="Tài liệu" className="w-3/4 mx-auto">
            <FileInput source="attachments" label="File đính kèm" multiple />
        </Section>
        </TabsContent> */}
    </Tabs>
  );
};

ProjectForm.GeneralInfo = () => {
  return (
    <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2">
      <TextInput source="name" label="Tên dự án" />
      <TextInput source="location" label="Địa điểm" />
      <ThousandSeparatorTextInput source="investment" label="Số tiền đầu tư" />
      <DatepickerInput source="start_date" label="Thời gian khởi công" />
      <DatepickerInput source="expected_end_date" label="Thời gian hoàn thành dự kiến" />
      <TextareaInput
        className="lg:col-span-3 md:col-span-2 sm:col-span-1"
        source="description"
        label="Mô tả dự án"
      />
    </div>
  );
};

export const transformBeforeSave = inputData => {
  const newData = {
    ...inputData,
    members: inputData.members
      ? JSON.stringify(inputData.members.map?.(m => ({id: m.id, role: m.pivot.role || ''})) || [])
      : undefined,
    start_date: inputData.start_date ? formatter.formatDateSQL(inputData.start_date) : undefined,
    expected_end_date: inputData.expected_end_date
      ? formatter.formatDateSQL(inputData.expected_end_date)
      : undefined,
    template_project_id: inputData.template_project ? inputData.template_project.id : undefined,
    template_project: undefined,
    workflow: undefined,
  };
  return newData;
};

ProjectForm.transformBeforeSave = transformBeforeSave;

export default ProjectForm;
